import Udesk from 'Udesk';
import { FieldFoundAdvanceWrapperResponse } from 'src/api/types';
import UdeskLocales from 'UdeskLocales';

export const getTypeName = (props: { inspectDataSource?: number; type?: number }) => {
    const { inspectDataSource, type } = props;

    return type === 1
        ? Udesk.enums.inspectDataSources.getName(inspectDataSource)
        : type === 2
        ? /* 智能标签 */ UdeskLocales['current'].components.variableFieldSelect.const.smartLabel
        : type === 3
        ? /* 预处理 */ UdeskLocales['current'].components.variableFieldSelect.const.pretreatment
        : type === 6
        ? /* 业务记录 */ UdeskLocales['current'].components.variableFieldSelect.const
              .businessRecords
        : type === 15
        ? /* 工单字段 */ UdeskLocales['current'].components.variableFieldSelect.const
              .workOrderFields
        : type === 16
        ? /* 客户信息 */ UdeskLocales['current'].components.variableFieldSelect.const
              .customerInformation
        : type === 19
        ? /* 关联工单 */ UdeskLocales['current'].components.variableFieldSelect.const
              .associatedWorkOrder
        : type === 23
        ? /* 语言字段 */ UdeskLocales['current'].components.variableFieldSelect.const.languageField
        : '-';
};

export const transformData = ({
    data,
    inspectDataSource,
}: {
    data: FieldFoundAdvanceWrapperResponse[];
    inspectDataSource: number;
}) => {
    const typeList = data.find((d) => d.source === inspectDataSource)?.typeList ?? [];

    return typeList
        .filter((t) => t.type !== 5 && t.fieldList?.length)
        .map((t) => {
            return {
                ...t,
                typeName: getTypeName({ inspectDataSource, type: t.type }),
            };
        });
};
